import { useState } from "react";
import { Button, Flex, HelpIndicator, Tag, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { SPACING } from "~/styles/variables";
import { CreateBulkArenaAccessModal } from "./CreateBulkArenaAccessModal";
import { EndBulkArenaAccessModal } from "./EndBulkArenaAccessModal";
import { roleParenthetical, bulkArenaAccessBlock } from "./styles_vanilla.css";

const BULK_ARENA_ACCESS_HELP =
  "Super-user style permission: grants the selected workspace role across every FA-managed client workspace. Most users should receive direct workspace assignments instead.";

export type BulkArenaAccessProps = {
  userId: string;
  hasBulkArenaAccess: boolean;
  roleGroupName: string;
};

export const BulkArenaAccess = ({
  userId,
  hasBulkArenaAccess,
  roleGroupName,
}: BulkArenaAccessProps) => {
  const [isEnableModalOpen, setIsEnableModalOpen] = useState(false);
  const [isDisableModalOpen, setIsDisableModalOpen] = useState(false);

  return (
    <>
      <div className={bulkArenaAccessBlock} data-testid="bulk-arena-access-block">
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          gap={SPACING.MEDIUM}
        >
          <Flex flexDirection="row" alignItems="center" gap={SPACING.SMALL} flexGrow={1}>
            <Text variant="strong-md">
              Access to all client workspaces
              {hasBulkArenaAccess && roleGroupName ? (
                <Text asSpan variant="regular-md" className={roleParenthetical}>
                  {` (${roleGroupName})`}
                </Text>
              ) : null}
            </Text>
            <Tag
              variant={hasBulkArenaAccess ? "success" : "neutral"}
              label={hasBulkArenaAccess ? "Active" : "Inactive"}
            />
            <HelpIndicator
              id="bulk-arena-access-tooltip"
              content={BULK_ARENA_ACCESS_HELP}
              placement="top"
            >
              <Icon
                data-testid="bulk-arena-access-tooltip-icon"
                type="question-circle"
                aria-label="About bulk arena access"
              />
            </HelpIndicator>
          </Flex>
          {hasBulkArenaAccess ? (
            <Button variant="neutral" onClick={() => setIsDisableModalOpen(true)}>
              Disable
            </Button>
          ) : (
            <Button variant="primary" onClick={() => setIsEnableModalOpen(true)}>
              Enable
            </Button>
          )}
        </Flex>
      </div>

      <CreateBulkArenaAccessModal
        isOpen={isEnableModalOpen}
        onClose={() => setIsEnableModalOpen(false)}
        userId={userId}
      />

      <EndBulkArenaAccessModal
        isOpen={isDisableModalOpen}
        onClose={() => setIsDisableModalOpen(false)}
        roleGroupName={roleGroupName}
        userId={userId}
      />
    </>
  );
};
